import { render, staticRenderFns } from "./ReplacementForm.vue?vue&type=template&id=5380dd41"
import script from "./ReplacementForm.vue?vue&type=script&lang=js"
export * from "./ReplacementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports